import { render, staticRenderFns } from "./selection-on-map.vue?vue&type=template&id=5c04f7b4&scoped=true&"
import script from "./selection-on-map.vue?vue&type=script&lang=js&"
export * from "./selection-on-map.vue?vue&type=script&lang=js&"
import style0 from "./selection-on-map.vue?vue&type=style&index=0&id=5c04f7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04f7b4",
  null
  
)

export default component.exports